import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { Idle } from '@ng-idle/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { BehaviorSubject } from 'rxjs'
import { CsvFileType, UploadCsvEvent, ValidateCsvRequest } from 'src/app/shared/models/csv/validate-csv'
import { PRICING_ADMIN_CSV_SCHEMAS } from './pricing-admin-upload-schemas'

interface FileError {
   index: string
   message: string
}

@Component({
   selector: 'vc-pricing-admin-upload-csv-modal',
   templateUrl: './pricing-admin-upload-csv-modal.component.html',
   styleUrl: './pricing-admin-upload-csv-modal.component.scss',
   standalone: false,
})
export class VetcorUploadCsvModalComponent {
   displayModal = true
   selectedSchema: { tableName: string; schema?: { name: string; type: string; nullable: boolean }[] }

   @Input() isSubmittingCsv = new BehaviorSubject<boolean>(false)
   @Input() errorMessages = new BehaviorSubject<FileError[]>([])
   @Input() warningMessages = new BehaviorSubject<FileError[]>([])
   @Output() onUploadCsv = new EventEmitter<UploadCsvEvent>()
   @Output() onSelectCsv = new EventEmitter<ValidateCsvRequest>()
   @Input() isValidating = new BehaviorSubject<boolean>(false)

   @ViewChild('fileUpload') fileUpload: any

   csvUploadOptions = [
      { label: 'Hospital Pricing CSV', fileUploadType: 'pricingFileUpload' },
      { label: 'Batch Updates', fileUploadType: 'batchFileUpload' },
      { label: 'Rules CSV', fileUploadType: 'rulesFileUpload' },
      { label: 'Rule Sets CSV', fileUploadType: 'ruleSetsFileUpload' },
   ]
   selectedCsvUploadType: any

   sourceInputValue: string = ''
   pipelines: { id: number; label: string; pipelineName: string; schema: string }[] = [
      {
         id: 1,
         label: 'Prices',
         pipelineName: 'PricingUpdate Import Records',
         schema: 'pricingUpdateDbx',
      },
      {
         id: 2,
         label: 'Cycle Import',
         pipelineName: 'PricingUpdateBatch Import',
         schema: 'batchFileUpload',
      },
   ]
   selectedPipeline: { id: number; pipelineName: string; label: string; schema: string }
   @Input() isSubmittingDbx = new BehaviorSubject<{ source: string; pipeline: string }>({ source: '', pipeline: '' })

   constructor(private bsModalRef: BsModalRef, private idle: Idle) {
      this.idle.onTimeout.subscribe(() => {
         this.onClose()
      })
   }

   onClose(): void {
      this.bsModalRef.hide()
      this.errorMessages.next([])
      this.warningMessages.next([])
   }

   onSetPipeline(pipeline: any) {
      this.selectedPipeline = pipeline
      this.selectedSchema = PRICING_ADMIN_CSV_SCHEMAS[pipeline.schema]
      this.sourceInputValue = this.selectedSchema?.tableName
   }

   resetErrorsAndWarnings() {
      this.errorMessages.next([])
      this.warningMessages.next([])
      if (this.fileUpload) {
         this.fileUpload.fileUpload.clear()
         this.fileUpload.onClear()
      }
   }

   uploadFile(event: any, fileUploadType: 'pricingFileUpload' | 'batchFileUpload' | 'rulesFileUpload' | 'ruleSetsFileUpload') {
      event.fileType = this.GetFileType(fileUploadType)
      this.onUploadCsv.emit(event)
   }

   selectFile(event: any, fileUploadType: 'pricingFileUpload' | 'batchFileUpload' | 'rulesFileUpload' | 'ruleSetsFileUpload') {
      var expectedHeaders: string[] = PRICING_ADMIN_CSV_SCHEMAS[fileUploadType].schema.map((x) => x.name)
      var validateRequest = new ValidateCsvRequest(event.data, event.fileName, expectedHeaders, this.GetFileType(fileUploadType))
      this.onSelectCsv.emit(validateRequest)
   }

   GetFileType(fileUploadType: 'pricingFileUpload' | 'batchFileUpload' | 'rulesFileUpload' | 'ruleSetsFileUpload'): CsvFileType {
      switch (fileUploadType) {
         case 'pricingFileUpload':
            return CsvFileType.HospitalPricing
         case 'batchFileUpload':
            return CsvFileType.BatchUpdates
         case 'rulesFileUpload':
            return CsvFileType.Rules
         case 'ruleSetsFileUpload':
            return CsvFileType.RuleSets
         default:
            return null
      }
   }

   downloadSampleCsv(fileUploadType: 'pricingFileUpload' | 'rulesFileUpload' | 'ruleSetsFileUpload') {
      let csvContent =
         PRICING_ADMIN_CSV_SCHEMAS[fileUploadType].schema.map((x) => x.name).join(',') + '\n' + PRICING_ADMIN_CSV_SCHEMAS[fileUploadType].sampleData
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `${fileUploadType}-sample.csv`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
   }

   onSubmitDbx() {
      if (this.sourceInputValue?.length === 0) {
         alert('Source must have a value')
      } else {
         this.isSubmittingDbx.next({ source: this.sourceInputValue, pipeline: this.selectedPipeline.pipelineName })
      }
   }

   getSelectedCsvSchema(fileUploadType: any) {
      return PRICING_ADMIN_CSV_SCHEMAS[fileUploadType]?.schema
   }
}
